import { useEffect } from "react";
import { useStore } from "../StateProvider";
import {
  FaBackwardFast,
  FaBackwardStep,
  FaForwardFast,
  FaForwardStep,
} from "react-icons/fa6";

const Pagination = ({ onchange = () => { } }) => {
  const store = useStore();
 
  useEffect(() => {
    if (onchange && typeof onchange === "function" && !onchange.isGlobalWrapper) {
      const currentCallback = store.getsystemvalue("pagecallback");
      if (currentCallback !== onchange) {
        store.setsystemvalue("pagecallback", onchange);
      }
    }
  }, [onchange]);

  const pageSize = store.getvalue("pagesize");
  const currentPage = Number(store.getvalue("currentpage"));
  const totalPage = Number(store.getvalue("totalpage"));
  const totalRecords = Number(store.getvalue("totalrecords"));

  const from = (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, totalRecords);
 const defaultOptions = [20, 30, 40, 50, 100, 1000];
  const dynamicOptions = new Set([...defaultOptions, pageSize]); // ensures current pagesize is shown
  const sortedOptions = [...dynamicOptions].sort((a, b) => a - b);
  return (
    <div className="flex items-center gap-4">

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium">Rows per page:</label>
        <select
          value={pageSize}
          onChange={(e) => {
            const newSize = Number(e.target.value);
            store.setvalue("pagesize", newSize);
            store.setvalue("currentpage", 1);
            onchange(1, newSize);
          }}
          className="border rounded px-2 py-1 text-sm"
        >
          {sortedOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>

      </div>
      <div className="flex gap-3 items-center ">
        <FaBackwardFast
          className="cursor-pointer"
          onClick={() => {
            store.setvalue("currentpage", "1");
            onchange(1);
          }}
        />
        <FaBackwardStep
          className="cursor-pointer"
          onClick={() => {
            let init = Number(store.getvalue("currentpage"));
            let total = store.getvalue("totalpage");
            if (init > 1) {
              store.setvalue("currentpage", init - 1);
              onchange(init - 1);
            }
          }}
        />
        <input
          className="w-6 border text-center"
          type="text"
          value={store.getvalue("currentpage")}
          onChange={(e) => {
            let num = Number(e.target.value).toString();
            if (num == 0) {
              store.setvalue("currentpage", "");
              onchange("");
            } else if (Number(num) > store.getvalue("totalpage")) {
              store.setvalue("currentpage", "");
              onchange(1);
            } else if (num != "NaN") {
              store.setvalue("currentpage", num);
              onchange(num);
            }
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              store.setvalue("currentpage", "1");
              onchange(1);
            }
          }}
        />
        <h1 style={{ userSelect: "none" }}> {from} – {to} of {totalRecords} </h1>
        <FaForwardStep
          className="cursor-pointer"
          onClick={() => {
            let init = Number(store.getvalue("currentpage"));
            let total = store.getvalue("totalpage");
            if (init < total) {
              store.setvalue("currentpage", init + 1);
              onchange(init + 1);
            }
          }}
        />
        <FaForwardFast
          className="cursor-pointer"
          onClick={() => {
            store.setvalue("currentpage", store.getvalue("totalpage"));
            onchange(store.getvalue("totalpage"));
          }}
        />
        {/* <div className="flex items-center gap-2">
          <label className="text-xs font-bold"></label>
        </div> */}


      </div>
    </div>
  );
};

export default Pagination;
